
    var riot = require('riot')
    //src: starling/src/tags/modal-extensions/add-on-panel.html
riot.tag2('add-on-panel',
  '<div class="link-panel_body"> <span class="link-panel_icon_container"> <svg class="link-panel_icon"> <use xlink:href="#{icon}-icon"></use> </svg> </span> <div class="link-panel_content"> <h3 class="link-panel_title">{title}</h3> <p class="link-panel_description">{description}</p> </div> <switch name="{name}-feature" checked="{isEnabled()}" toggle="{toggleFeature}" disabled="{!canEdit()}"></switch> </div>',
  '',
  'class="link-panel {link-panel--disabled: !isEnabled()}"', function(opts) {
'use strict';

var _this = this;

var canvas = this.parent.opts.canvas;
var operation = canvas.operation;

this.canEdit = function () {
  return canvas.store.access.permission === 'edit';
};

this.isEnabled = function () {
  return canvas.isFeatureEnabled(_this.name);
};

this.toggleFeature = function () {
  var feature = _this.name;

  var value = _this.isEnabled() ? 0 : 1;

  canvas.toggleFeature({ feature: feature, value: value });
  operation.updateMapEnabledFeature({ feature: feature, value: value, onFailure: console.error });

  _this.update();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('add-on-panel')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/modal-extensions/add-on-panel.html
// module id = 775
// module chunks = 0